import { useCollectionHandler } from "./useCollectionHandler"
import { userEventCollectionKey } from "src/schema"
import type { UserEvent } from "src/types"

export function useUserEventsHandler() {
  return useCollectionHandler<UserEvent>(userEventCollectionKey)
}
